// File: /src/components/ClientsTable.js

import React, { useState } from 'react';
import TableSortHeader from './TableSortHeader';
import { useSortableData } from '../hooks/useSortableData';
import '../styles/GridClients.css';

const ClientsTable = ({
	clients,
	openClientModal,
	selectedClients,
	toggleSelectClient,
	cardColors,
	onColorChange,
	isShowingArchived,
}) => {
	const { sortedItems, sortConfig, handleSort } = useSortableData(clients, {
		key: 'id',
		direction: 'asc',
	});
	const [showTable, setShowTable] = useState(() => {
		const savedState = localStorage.getItem('clientsTableVisible');
		return savedState !== null ? JSON.parse(savedState) : true;
	});

	const tableRowStyle = {
		cursor: 'pointer',
	};

	const toggleTableVisibility = () => {
		setShowTable((prev) => {
			const newState = !prev;
			localStorage.setItem(
				'clientsTableVisible',
				JSON.stringify(newState)
			);
			return newState;
		});
	};

	const handleSelectAll = (event) => {
		const allClientIds = sortedItems.map((client) => client.id);
		if (event.target.checked) {
			allClientIds.forEach((id) => {
				if (!selectedClients.includes(id)) {
					toggleSelectClient(id);
				}
			});
		} else {
			allClientIds.forEach((id) => {
				if (selectedClients.includes(id)) {
					toggleSelectClient(id);
				}
			});
		}
	};

	return (
		<div className="table-section">
			<h3 onClick={toggleTableVisibility} style={{ cursor: 'pointer' }}>
				Clientes {showTable ? '-' : '+'}
			</h3>
			{showTable && (
				<div className="table-container">
					<table>
						<thead>
							<tr>
								<th>
									<input
										type="checkbox"
										className="grid-client-checkbox"
										checked={
											sortedItems.length > 0 &&
											sortedItems.every((client) =>
												selectedClients.includes(
													client.id
												)
											)
										}
										onChange={handleSelectAll}
									/>
								</th>
								<TableSortHeader
									label="ID"
									sortKey="id"
									currentSortConfig={sortConfig}
									onSort={handleSort}
								/>
								<th>Label</th>
								<TableSortHeader
									label="Nome"
									sortKey="name"
									currentSortConfig={sortConfig}
									onSort={handleSort}
								/>
								<TableSortHeader
									label="Email"
									sortKey="email"
									currentSortConfig={sortConfig}
									onSort={handleSort}
								/>
								<TableSortHeader
									label="CPF/CNPJ"
									sortKey="cpf_cnpj"
									currentSortConfig={sortConfig}
									onSort={handleSort}
								/>
								<TableSortHeader
									label="Telefone"
									sortKey="phone"
									currentSortConfig={sortConfig}
									onSort={handleSort}
								/>
								<TableSortHeader
									label="Endereço"
									sortKey="address"
									currentSortConfig={sortConfig}
									onSort={handleSort}
								/>
							</tr>
						</thead>
						<tbody>
							{sortedItems.length === 0 ? (
								<tr>
									<td colSpan="8">
										{isShowingArchived 
											? "Nenhum cliente arquivado."
											: "Nenhum cliente cadastrado."}
									</td>
								</tr>
							) : (
								sortedItems.map((client) => (
									<tr
										key={client.id}
										style={tableRowStyle}
										onClick={() => openClientModal(client)}
									>
										<td>
											<input
												type="checkbox"
												className="grid-client-checkbox"
												checked={selectedClients.includes(
													client.id
												)}
												onClick={(e) =>
													e.stopPropagation()
												}
												onChange={() =>
													toggleSelectClient(
														client.id
													)
												}
											/>
										</td>
										<td>{client.id}</td>
										<td
											onClick={(e) => e.stopPropagation()}
											style={{
												textAlign: 'center',
											}}
										>
											<div
												className="color-label"
												style={{
													width: '24px',
													height: '24px',
													backgroundColor:
														cardColors[client.id] ||
														'#ccc',
													borderRadius: '4px',
													margin: '0 auto',
													cursor: 'pointer'
												}}
												onClick={(e) => {
													e.stopPropagation();
													onColorChange(client.id);
												}}
											/>
										</td>
										<td>{client.name}</td>
										<td>{client.email}</td>
										<td>{client.cpf_cnpj}</td>
										<td>{client.phone}</td>
										<td>{client.address}</td>
									</tr>
								))
							)}
						</tbody>
					</table>
				</div>
			)}
		</div>
	);
};

export default ClientsTable;
